import "apps/pathways/styles/components/pathway-resume.scss";
import React from 'react';
import { Link } from 'library/util/core-router';
import Loading from 'components/loading';
import { CompletedData } from 'apps/pathways/services/pathway';

import ResumeSvg from 'apps/pathways/icons/resume.svg';
import ResumeDownload from 'apps/pathways/components/resume-download';
import CheckSvg from 'apps/pathways/icons/check.svg';

const Complete = ({ complete, children }) => (
  complete
    ? <CheckSvg style={{fontSize: '2em'}} className="icon" />
    : children
);

const ResumeProgress = ({ progress=0, width=113, height=158 }) => (
  <svg width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="pathway-resume-svg-clip" x="0" y="0" width={width} height={height * (progress / 100)}>
        <rect x="0" y={height - height * (progress / 100)} width={width} height={height * (progress / 100)} fill="blue" />
      </clipPath>
      <ResumeSvg id="pathway-resume-svg" />
    </defs>
    <use xlinkHref="#pathway-resume-svg" />
    <use className="pathway-resume-svg" xlinkHref="#pathway-resume-svg" clipPath="url(#pathway-resume-svg-clip)" />
  </svg>
);

export default class PathwayResume extends React.Component {

  state = {
    completed_data: {},
    loading: true
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({
      loading: true
    });

    this.setState({
      loading: false,
      completed_data: await CompletedData()
    });
  }

  get complete() {
    return Object.values(this.state.completed_data).reduce((a,b)=>a&&b,true);
  }

  get percent() {
    return (Object.values(this.state.completed_data).map(v=>v?1:0).reduce((a,b)=>a+b,0) / Object.keys(this.state.completed_data).length) * 100;
  }

  get title() {
    return this.complete
      ? 'Profile Complete'
      : 'Complete your Profile';
  }

  get description() {
    return this.complete
      ? `Completing your profile allows us to better customize your pathway. The more specific you can be, the more accurate and relevant we can design your career pathways.`
      : `Sharing your Experience and Other Skills configures your Hard Skills profile. Combined with your Soft Skills profile and Education, we determine your Pathway. The more specific you are, the better your results.`;
  }

  render() {
    const {
      loading,
      completed_data
    } = this.state;

    if (loading) {
      return <Loading className="pathway-resume" />;
    }

    return (
      <div className="pathway-resume">
        <div className="pathway-resume-left">
          <h2>{ this.title }</h2>
          <p>{ this.description }</p>
          <ul>
            <li>Survey <Complete complete={completed_data.survey}><Link className="button button-auxilary-3" to="/pathways/start/3">Start</Link></Complete></li>
            <li>Experiential <Complete complete={completed_data.experiential}><Link className="button button-auxilary-3" to={{ pathname: '/pathways/start/2', params: {startAt: 'work_histories' }}}>Start</Link></Complete></li>
            <li>Education <Complete complete={completed_data.education}><Link className="button button-auxilary-3" to={{ pathname: '/pathways/start/2', params: {startAt: 'education_histories'}}}>Start</Link></Complete></li>
            <li>Skills <Complete complete={completed_data.skills}><Link className="button button-auxilary-3" to={{ pathname:'/pathways/start/2', params:{startAt: 'skills'}}}>Start</Link></Complete></li>
          </ul>
          <Link to="/pathways/start/2">update information</Link>
        </div>
        <div className="pathway-resume-spacer" />
        <div className="pathway-resume-right">
          <ResumeProgress progress={this.percent} />
          <ResumeDownload disabled={!completed_data.survey} />
        </div>
      </div>
    );
  }
}
